"use strict";

var _classCallCheck = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Roll = void 0;

var OptionsColor_1 = require("../../OptionsColor");

var RollLight_1 = require("./RollLight");

var Utils_1 = require("../../../../Utils");

var Enums_1 = require("../../../../Enums");

var Roll = /*#__PURE__*/function () {
  function Roll() {
    _classCallCheck(this, Roll);

    this.darken = new RollLight_1.RollLight();
    this.enable = false;
    this.enlighten = new RollLight_1.RollLight();
    this.mode = Enums_1.RollMode.vertical;
    this.speed = 25;
  }

  _createClass(Roll, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.backColor !== undefined) {
        this.backColor = OptionsColor_1.OptionsColor.create(this.backColor, data.backColor);
      }

      this.darken.load(data.darken);

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      this.enlighten.load(data.enlighten);

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      if (data.speed !== undefined) {
        this.speed = (0, Utils_1.setRangeValue)(data.speed);
      }
    }
  }]);

  return Roll;
}();

exports.Roll = Roll;